import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageConfig } from '@models';
import { ApiService } from './api-service';

@Injectable({
  providedIn: 'root',
})
export class PageConfigService {
  private readonly apiService = inject(ApiService);

  getPageConfig(): Observable<PageConfig> {
    return this.apiService.get('pages');
  }
}
